import { useEffect, useMemo, useState } from "react";
import { IOption, ISwatchContent } from "../../types/customizer";
import RingSizeSelect from "../RingSizeSelect";

import './sizeFilter.scss';
import { useRingCustomizerContext } from "../../context/RingCustomizerContext";

export interface ISizeFilterProps {
  content: ISwatchContent;
  onChange: (updated: any) => void;
  innerTab?: number;
  isFetching: boolean;
}

// Matches the logged-in size selector on lashbrook-web
const SizeFilter = ({ content, onChange, isFetching, innerTab = 1 }:ISizeFilterProps) => {
  const { subpath } = useRingCustomizerContext();
  const { fieldType } = content;
  const options: Array<IOption> = content.options as Array<IOption>;

  const [pendingSku, setPendingSku] = useState('');

  const selectedSku = options.find((option) => option.selected)?.sku ?? '';
  const value = pendingSku || selectedSku;

  useEffect(() => {
    if (!isFetching) setPendingSku('');
  }, [isFetching]);

  const handleChange = (sku: string) => {
    if (!sku || sku === selectedSku) return;
    setPendingSku(sku); // keeps the new size showing until the response is received
    onChange({ [fieldType]: sku });
  };

  const selectOptions = useMemo(
    () => options.map((option) => ({ value: option.sku, label: option.name })),
    [options]
  );

  return (
    <div className="tw-flex tw-justify-start tw-pb-2 swatch-filter-border" style={{ height: `calc(100% - ${45 * innerTab}px)` }}>
      <div className="tw-w-full sm:tw-max-w-md tw-px-4 tw-pb-6 tw-h-full tw-overflow-y-auto">
        {['revolution', 'stonebrook-jewelry', 'foundry', 'origin-jewelry'].includes(subpath) && (
          <div className="tw-mt-4 tw-mb-4 tw-p-3 tw-bg-gray-100 tw-rounded-md tw-text-sm tw-text-gray-600 tw-max-w-full tw-overflow-hidden tw-box-border">
            <p className="tw-font-semibold tw-flex tw-items-center tw-gap-1">
              <svg className="tw-w-4 tw-h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
              </svg>
              Not sure of your ring size?
            </p>
            <p className="tw-mt-1">No need to decide yet — leave the default size selected and click Finish Your Design. In the next step, you'll have the option to add <strong>Free Ring Sizers</strong>.</p>
          </div>
        )}
        <div className="ring-size tw-mt-5">
          <div className="ring-size__control">
            <RingSizeSelect
              label="Ring Size"
              options={selectOptions}
              value={value}
              onChange={handleChange}
              loading={isFetching && !!pendingSku}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SizeFilter;
